import { ProfileMapper } from '../../common/mappers/ProfileMapper';
import { Profile } from '../../common/models/Profile';
import { BaseGQLService } from '../../common/services/BaseGQLService';
import { ProjectMapper } from '../../projects/common/mappers/ProjectMapper';
import { Project } from '../../projects/common/models/Project';
import { UserMapper } from '../mappers/UserMapper';
import { User } from '../models/User';

export const GET_PROJECTS_QUERY = `
query {
  viewer {
    name
    organization {
      projects(sorters: [{field: name, order: ASC}]) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}`;

export const GET_PROFILES_QUERY = `
query {
  viewer {
    name
    organization {
      profiles(sorters:[{field:name order:ASC}]) {
        edges {
          node {
            id
            name
            type
          }
        }
      }
    }
  }
}`;

export const GET_TESTERS_QUERY = `
query {
  viewer {
    name
    organization {
      testers{
        edges {
          node {
            id
            name
            preferredName
          }
        }
      }
    }
  }
}`;

export class OrganizationService extends BaseGQLService {
  private readonly projectMapper = new ProjectMapper();
  private readonly profileMapper = new ProfileMapper();
  private readonly userMapper = new UserMapper();

  async getProjects(): Promise<Project[]> {
    return this.query(
      GET_PROJECTS_QUERY,
      {},
      (data) => data.viewer.organization.projects.edges.map((edge: any) => this.projectMapper.mapGQLModel(edge.node)) || []
    );
  }

  async getProfiles(): Promise<Profile[]> {
    return this.query(
      GET_PROFILES_QUERY,
      {},
      (data) => data.viewer.organization.profiles.edges.map((edge: any) => this.profileMapper.mapGQLModel(edge.node)) || []
    );
  }

  async getTesters(): Promise<User[]> {
    return this.query(GET_TESTERS_QUERY, {}, (data) => data.viewer.organization.testers.edges.map((edge: any) => this.userMapper.mapGQLModel(edge.node)) || []);
  }
}
